import { render, staticRenderFns } from "./anosafra_multiselect.vue?vue&type=template&id=70b96450&scoped=true"
import script from "./anosafra_multiselect.vue?vue&type=script&lang=js"
export * from "./anosafra_multiselect.vue?vue&type=script&lang=js"
import style0 from "./anosafra_multiselect.vue?vue&type=style&index=0&id=70b96450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b96450",
  null
  
)

export default component.exports